<template>
    <div class="expire-message" v-show="!createAllowed">
        <div class="expire-message-content">
            Срок сдачи отчетности истек.
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
    export default {
        computed: {
		...mapGetters(['createAllowed']),
	},
    }
</script>

<style lang="scss" scoped>
.expire-message {
    
    // padding: 1rem;
    padding-top: 1rem;
}

.expire-message-content {
    background: #FF6B6B;
    max-width: 600px;
    margin: 0 auto;
    text-align: center;
    color: #fff;
    border-radius: 10px;
    padding: 1rem;
}
</style>